<!-- <template>
    <div class="md-empty cms-use" :class="[theme,blockName]">
        cms-use md-empty md-team new-style4
        is empty
    </div>
</template> -->
<script>
import { h } from "vue";
import MODULE_GROUP_NAME_MAP from '../../../../cms/src/modules/module-name.json';
export default {
    name: "MdEmpty",
    render(ctx) {
        const mdData = ctx.mdData || {};
        const moduleName = mdData.name;
        const blockName = MODULE_GROUP_NAME_MAP[moduleName] || moduleName;
        let iconname = 'icon-drawar_02';
        const siteType = false;
        const noDataTip = siteType === 'SubSite' ? ''
            : ` Please double-click to configure the ${blockName} block.`;
        return h('div', {
            class: `cms-use md-empty ${moduleName} ${mdData.theme}`,
        }, [
            h('div', {
                class: `empty-content`
            },
            [
                h('span', {
                    class: `iconfont ${iconname} empty-img`
                }),
                h('i', `No Data.${noDataTip}`)
            ])
        ]);
    }
}
</script>